import { EmployeeViewContent } from "@/pages/employees/widgets/EmployeeViewContent.tsx";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import {
  Box,
  BoxWithScroll,
  ButtonIcon,
  ButtonLink,
  FontAwesomeIcon,
  Stack,
  Title,
} from "@skailer-com/uikit";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface EmployeeViewRightPaneProps {
  employeeId?: number;
  onClose: () => void;
}

export function EmployeeViewRightPane({ employeeId, onClose }: EmployeeViewRightPaneProps) {
  const { t } = useTranslation();

  useEffect(() => {
    analyticsService.trackEvent(analyticEvents.employees.viewedEmployee, {
      [analyticProperties.id]: employeeId,
      [analyticProperties.source]: "Right pane",
    });
  }, [employeeId]);

  return (
    <Stack className={"h-full"}>
      <Stack
        direction={"horizontal"}
        justify={"between"}
        items={"center"}
        className={"px-6 pt-6 pb-4"}
      >
        <Title header={t("core:profile")} size={"md"} />
        <ButtonIcon
          variant={"plain"}
          icon={<FontAwesomeIcon icon={"fa-light fa-xmark"} />}
          onClick={onClose}
        />
      </Stack>

      <BoxWithScroll className={"grow"}>
        <Box className={"px-6 pb-6"}>
          <EmployeeViewContent employeeId={employeeId} />
        </Box>
      </BoxWithScroll>

      <Box className={"px-6 pb-6 pt-(--gap-smd)"}>
        <ButtonLink
          className="w-full"
          size="lg"
          href={`/employees/${employeeId}`}
          target={"_blank"}
        >
          {t("core:view_profile")}
        </ButtonLink>
      </Box>
    </Stack>
  );
}
